/**
 * Função sanitiza uma entrada de input e remove caracteres de CR LF.
 * @param {event} e - evento de onchange.
 * @returns {any} retorna o valor do evento sanatizado.
 */
const sanitize = (e) => {
  return e.target.value.replace(/[\r\n]/g, "");
};
export default sanitize;
